module.exports = __webpack_public_path__ + "img/product_83.6d8eb42.webp";